module.exports = __webpack_public_path__ + "media/images/common/logo/logo-1eee9e450828dd5f966facd3c08e393a.svg";